import { TAX_REPORT_DATA, TAX_SUMMARIZE, } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iTaxReport";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initState = {
    tax: {
        taxSummary: {
            tradingGain: "",
            shortTermGain: "",
            longTermGain: "",
            totalGain: "",
        },
        taxDetail: [],
    },
    summarize: false,
};
const TaxReducer = (state = initState, action) => {
    switch (action.type) {
        case TAX_REPORT_DATA:
            return Object.assign(Object.assign({}, state), { tax: action.payload.tax });
        case TAX_SUMMARIZE:
            return Object.assign(Object.assign({}, state), { summarize: action.payload.summarize });
        default:
            return state;
    }
};
export default combineReducers({
    reducersData: TaxReducer,
    commonData: commonOnePlatFormReducer,
});
